<template>
  <v-app>
    <v-container class="my-2">
      <v-layout column align-center>
        <h1>Ariel German</h1>
        <h2>Software Engineer</h2>
        <h3>Full-Stack Web Developer</h3>
        <a href="https://www.linkedin.com/in/ariel-german-b56b698a/" target="_blank">LinkedIn</a>
        <p class="text-xs-center summary">Passionate about creating solutions for ordinary people using web development. 
          Currently in a position where I can break down complex problems into bite size fun puzzles. Naturally became the go to person 
          within my circle of friends and family for anything tech related, fueling my drive to stay up to date with my skills. Problem solving is my superpower. </p>
        Built in NY, New York
      </v-layout>
      <hr>
      <v-layout row class="my-3" justify-space-around="" wrap>
        <v-flex xs6 sm2 class="pa-2 text-xs-center skills">
          <ul>
            <h4>Core Skills</h4>
            <li>Javascript / ES6</li>
            <li>VueJS</li>
            <li>NodeJS / REST</li>
            <li>HTML / CSS / SASS</li>
            <li>MYSQL</li>
            <li>Version Control</li>
          </ul>
        </v-flex>
        <v-flex xs6 sm2 class="pa-2 text-xs-center skills">
          <ul>
            <h4>Backend Skills</h4>
            <li>ExpressJS/ PUG</li>
            <li>PassportJS</li>
            <li>SequelizeJS</li>
            <li>Heroku / Firebase</li>
          </ul>
        </v-flex>
        <v-flex xs6 sm2 class="pa-2 text-xs-center skills">
          <ul>
            <h4>Frontend Skills</h4>
            <li>Vuetify</li>
            <li>Vuex</li>
            <li>Bootstrap</li>
            <li>PWA</li>
            <li>Wordpress</li>
          </ul>
        </v-flex>
        
        <v-flex xs6 sm2 class="pa-2 text-xs-center skills" >
          <ul>
            <h4>Other</h4>
            <li>Google APIs</li>
            <li>Bitbucket Pipelines</li>
            <li>AWS S3</li>
            <li>Slack / Trello</li>
            <li>Photoshop / Illustrator</li>
          </ul>
        </v-flex>

        <v-flex xs6 sm2 class="pa-2 text-xs-center skills" >
          <ul>
            <h4>Soft Skills</h4>
            <li>Problem Solving</li>
            <li>Decision Making</li>
            <li>Strong Work Ethic</li>
            <li>Adaptability</li>
            <li>Accountability</li>
            <li>Thoughtfull</li>
          </ul>
        </v-flex>
        
      </v-layout>
      <hr>
      <v-layout column="">
        <v-layout row align-baseline="">
          <h2>Projects</h2>
          <v-spacer></v-spacer>
          <v-switch v-model="visual" label="Turn on Visual Walk-Through"></v-switch>
        </v-layout>
        
        <section class="my-2">
          <v-layout row wrap>
            <v-flex xs12 :class="{ sm9: visual}">
              <v-container>
                <h3>CellSmart Platform</h3>
                <p>Built a monolithic backend service for a retail management platform. The api exposed the creation and modification of invoices, customer database, reports, and many other features.
                  The platform targeted multiple users from retail store owners, to wholesale resellers, so the backend was built to be flexible enough to facilitate agile develoment of features.
                </p>
                <ul>
                  <li>400+ endpoints</li>
                  <li>Tested Use Cases</li>
                  <li>Integrated with Stripe API, Twillio, Sendgrid, Google API, Amazon S3, and other third party API services</li>
                  <li>Supported 3+ front-end clients</li>
                  <li>Support for white-label front-end clients</li>
                </ul>
              </v-container>
            </v-flex>
            <v-flex xs12 sm3>
              <img v-if="visual" src="./assets/gifs/services.gif" style="width:100%; " />
            </v-flex>
          </v-layout>
        </section>
        <section class="my-2">
          <v-container>
            <h3>CellSmart MVNO <v-btn icon small href="https://mvno.cellsmart.biz" target="_blank"><v-icon>link</v-icon></v-btn></h3>
            <p>
              Built a front-end client for the CellSmart Platform to service MVNOs (Mobile Virtual Network Operators). The single page application helps MVNO manage their subscribers, sim card inventory, and retailers who sell their services.
            </p>
            <img v-if="visual" src="./assets/gifs/mvno.gif" style="width:100%"/>
          </v-container>
        </section>
        <section class="my-2">
          <v-layout row wrap>
            <v-flex xs12 :class="{ sm9: visual}" order-sm2>
              <v-container>
                <h3>CellSmart Terminal <v-btn icon small href="https://app.cellsmart.biz" target="_blank"><v-icon>link</v-icon></v-btn> <v-btn icon href="https://www.youtube.com/watch?v=DJomuCGew34" target="_blank"><v-icon>play_circle_filled</v-icon></v-btn></h3>
                <p>
                  Built a front-end client for the CellSmart Platform to service retail stores. The single page application helps retail store owners manage their transactions, employees and customers. Users can also opt in for paid features
                  like inventory management, work order (repair) ticketeting system, custom industry related business logic triggers, and many other features that I created as part of a marketplace of opt in features. This application was also
                  deployed as a stand alone Electron app and I also ported the web version to IOS and Android using Ionic and Capacitor JS.
                </p>     
              </v-container>         
            </v-flex>
            <v-flex xs12 sm3 order-sm1>
              <img v-if="visual" src="./assets/gifs/register.gif" style="width:100%" />    
            </v-flex>
          </v-layout>
          
        </section>
        <section class="my-2">
          <v-container>
            <h3>CellSmart Back Office <v-btn icon small href="https://admin.cellsmart.biz" target="_blank"><v-icon>link</v-icon></v-btn></h3>
            <p>
              Built a front-end client for the CellSmart Platform to service retail store admins. The single page application helps retail stores owners manage their transactions, employees and customers across multiple locations. Users can 
              manage advance business logic features in order to customize their CellSmart Terminal experience to meet their needs.
            </p>
            <img v-if="visual" src="./assets/gifs/backoffice.gif" style="width:100%" />
          </v-container>
        </section>
        <section class="my-2">
          <v-container>
            <h3>CellSmartPOS.com<v-btn icon small href="https://cellsmartpos.com" target="_blank"><v-icon>link</v-icon></v-btn></h3>
            <p>
              Rebuilt the cellsmartpos.com website to make it modern and mobile friendly.
            </p>
            <img v-if="visual" src="./assets/gifs/cellsmartposcom.gif" style="width:100%" />
          </v-container>
        </section>
        <section class="my-2">
          <v-layout row wrap>
            <v-flex xs12 :class="{ sm9: visual}">
             <v-container>
                <h3>Bonventa <v-btn icon small href="https://terminal.bonventa.com" target="_blank"><v-icon>link</v-icon></v-btn></h3>
                <p>
                  Deployed a white labeled version of the CellSmart Terminal and Back office to display the potential for future partners to take our technology and rebrand it for an industry other than the
                  wireless retailer industry. Minor changes were made to the fork of the original code.
                </p>
             </v-container>
            </v-flex>
            <v-flex xs12 sm3>
              <img v-if="visual" src="./assets/gifs/bonventa.gif" style="width:100%" />
            </v-flex>
          </v-layout>          
        </section>

        <section class="my-2">
          <v-layout row wrap>
            <v-flex xs12 :class="{ sm9: visual}" order-sm2>
              <v-container>
                <h3>4pickup <v-btn icon small href="https://www.4pickup.us/" target="_blank"><v-icon>link</v-icon></v-btn></h3>
                <p>
                  Deployed a front-end client allowing business owners to easily post their business on a map with a menu or services they provide. The idea behind the project was to empower street vendors and gives them
                  an easy way to have online presence. Orders for pick up can be placed through the app and the business owner would be notified through SMS.
                </p>
              </v-container>
            </v-flex>
            <v-flex xs12 sm3 order-sm1>
              <img v-if="visual" src="./assets/gifs/4pickup.gif" style="width:100%"/>
            </v-flex>
          </v-layout>
          
          
        </section>
        <hr>
        <h2>Side Projects</h2>
        <section class="my-2">
          <v-layout row wrap>
           <v-flex xs12 :class="{ sm9: visual}">
            <v-container>
              <h3>Cibao Rental (Under-development) <v-btn icon small href="https://cibaorental.com" target="_blank"><v-icon>link</v-icon></v-btn></h3>
              <p>
                Designed and deployed a single page application that allows local vehicles owners in the Dominican Replublic to post their vehicle for rent. The application also gives tourist of the Dominican Republic access to vehicle rentals in remote areas
                at afordable prices.
              </p>
            </v-container>
           </v-flex>
            <v-flex xs12 sm3>
              <img v-if="visual" src="./assets/gifs/cibao.gif" style="width:100%" />
            </v-flex>
          </v-layout>
          
          
        </section>

        <section class="my-2">
          <v-container>
            <h3>ArielGerman.com (Under-development) <v-btn flat small href="https://arielgerman.com" target="_blank"><v-icon>link</v-icon>Recursion</v-btn></h3>
            <p>
              A VueJS single page application hosted on Firebase displaying the potential and skills of Ariel German, a software engineer from New York.
            </p>
            <img v-if="visual" src="./assets/gifs/website.gif" style="width:100%" />
          </v-container>
        </section>

        <section class="my-2">
         <v-container>
            <h3>Track My Flip (Under-development) <v-btn icon small href="https://trackmyflip.web.app/" target="_blank"><v-icon>link</v-icon></v-btn></h3>
            <p>
              A VueJS single page application allowing users to track the full life cycles of products they are fillping for profit. Users can record what items they want to purchase, previously purchased items, what they sold for, and what profit was made.
            </p>
         </v-container>
        </section>

        <section class="my-2">
         <v-container>
            <h3>Cats<v-btn icon small href="https://karinascats.herokuapp.com/" target="_blank"><v-icon>link</v-icon></v-btn></h3>
            <p>
              Hosted a small Heroku app displaying random cats. Because the internet needs more cats.
            </p>
         </v-container>
        </section>
      </v-layout>
      <hr>
      <v-layout column>
        <h2>Work Experience</h2>
        <h4> Chief Operating Officer <span><i>- CellSmart POS INT LLC (Jan 2016 - Present)</i></span></h4>
        <ul><li>Software Development
      <ul><li>Create partnership with third party service providers (credit card processing, business SMS messaging, etc.) and oversee code implementation</li><li>Create scope documents for upcoming projects based on product owner needs</li><li>Recruit team of developers for ongoing and upcoming projects</li><li>Lead Full Stack Developer on MVP projects</li><li>Redesigned and developed company website</li><li>Develop custom CRM for company and client use</li><li>Help maintain and release patches for older VBA products still in production </li><li>Research</li></ul></li><li> Management
      <ul><li>Managed and built relationships with 25 - 30 employees</li><li>Define employee functions and establish standard operating procedures for Sales, Technical Support, and Development teams. </li><li>Determine areas of improvement and implement solutions</li><li>Establish key performance indicators for every department and evaluate performance quarterly. </li></ul></li><li>
      Customer Support
      <ul><li>Help inexperienced technical support reps with problems they or their superiors can not solve.</li><li>Discover and implements way to engage customers and help them understand the product they use better</li><li>Increased customer retention by 25%</li><li>Increased customer satisfaction of flag ship product, evident through online reviews</li><li>Decreased the number of bottlenecks between customer feedback and implementation </li></ul></li><li>
      Sales
      <ul><li>Discovered and created opportunities and partnerships that would increase growth. </li><li>Revamped the way the sales team approached leads and provided them with more tools </li></ul></li></ul>

      <h4> Customer Support Representative <span><i>- CellSmart POS INT LLC(Apr 2014 - Jan 2016)</i></span></h4>
      <ul><li>Customer Support
      <ul><li>Train employees and clients on flag ship product</li><li>Help clients with software issues and perform feedback</li><li>Perform remote software installation</li><li>Troubleshoot software and physical hardware</li><li>Manage phone system software</li></ul></li><li>
      Quality Assurance
      <ul><li>Provide development team with UX feedback</li><li>Create use cases and discover software bugs</li><li>Test implementation solutions</li></ul></li><li>
      Media Manager
      <ul><li>Record and edit training videos for internal and external use</li><li>Create marketing material using Photoshop and Illustrator</li><li>Create post or blogs for Facebook and Twitter account</li></ul></li></ul>

      <h4> Cashier <span><i>- West Food Corp Deli (Jan 2014 - Apr 2014)</i></span></h4>
      <ul><li>Prcoessed customer's transaction and maintained cash drawer.</li><li>Provided exceptional customer service.</li><li>Prepared coffee and sandwich orders.</li><li>Performed deliveries to local customer's residence.</li><li>Purchased and transported inventory from Jetro.</li></ul>
      
      
      <h2>Education</h2>
      <p>AS, Computer Science CUNY Bronx Community College</p>

      <h2>Interest</h2>
      <ul>
        <li>Film Making and Editing</li>
        <li>Game Development</li>
        <li>Community Outreach</li>
      </ul>

      </v-layout>

      <v-layout column>
        Feel free to connect with me. <a href="https://www.linkedin.com/in/ariel-german-b56b698a/" target="_blank">LinkedIn</a>.
      </v-layout>
    </v-container>
   
    <v-footer  id="footer" app>
      <v-layout row justify-center>
        <span >&copy; 2018 Ariel German</span>
      </v-layout>
      
    </v-footer>
  </v-app>
</template>

<script>

export default {
  name: 'App',
  data() {
    return {
      visual: true,
    }
  }
}
</script>
<style>
a {
  text-decoration: none;
  font-size: 20px;
  font-weight: 800;
}
.skills > ul{
  list-style: none
}
.summary {
  font-weight: 700
}
</style>

